import {
  fetchCianApiSiteV1OffersSearchMeta,
  TCianApiSiteV1OffersSearchMetaRequest,
  TCianApiSiteV1OffersSearchMetaResponse,
} from '../repositories/monolith-python/cian-api/site/v1/offers/search/meta';
import { IApplicationContext } from '../types/application';

interface IGetMetaParameters {
  context: IApplicationContext;
  subdomain: string;
  parameters: TCianApiSiteV1OffersSearchMetaRequest;
}

export function getMeta({
  context,
  subdomain,
  parameters,
}: IGetMetaParameters): Promise<TCianApiSiteV1OffersSearchMetaResponse> {
  const { httpApi } = context;

  return fetchCianApiSiteV1OffersSearchMeta({
    httpApi,
    parameters,
    config: {
      subdomain,
    },
  });
}
